import { Component, OnInit, Input, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { Plan } from 'src/classes/plan';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmActionModalComponent } from 'src/app/confirm-action-modal/confirm-action-modal.component';
import { PaymentService } from 'src/services/payment/payment.service';

@Component({
  selector: 'app-plan-view',
  templateUrl: './plan-view.component.html',
  styleUrls: ['./plan-view.component.scss']
})
export class PlanViewComponent implements OnInit {

  @Input() plan: Plan;
  @Output() selectPlan = new EventEmitter<void>();

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private modalService: NgbModal,
    private paymentService: PaymentService
  ) { }

  ngOnInit() {
  }

  get isContact() {
    return this.plan && this.plan.name === "Enterprise";
  }

  isEnglishLocale() {
    return !(typeof this.locale === "string" && this.locale.toLowerCase().substring(0, 2) === "pt");
  }

  isTextPrice() {
    if (this.isEnglishLocale()) {
      return !(typeof this.plan.priceUSD !== "number" || !(this.plan.priceUSD > 1));
    }
    return !(typeof this.plan.priceBRL !== "number" || !(this.plan.priceBRL > 1));
  }

  getPlanPrice() {
    if (!this.plan) {
      return "no plan";
    }
    if (!this.plan.getPlanPrice) {
      return "no method";
    }
    return this.plan.getPlanPrice(this.isEnglishLocale());
  }

  getMonthlyDeliveries() {
    if (typeof this.plan.deliveries !== "number" || !(this.plan.deliveries > 1)) {
      if (this.isEnglishLocale()) {
        return "Unlimited";
      } else {
        return "Ilimitado";
      }
    }
    return Intl.NumberFormat((this.isEnglishLocale()) ? 'en-US' : 'pt-BR', { maximumFractionDigits: 0 }).format(this.plan.deliveries);
  }

  getDailyDeliveries() {
    const daily = this.plan.deliveries/30|0;
    return Intl.NumberFormat((this.isEnglishLocale()) ? 'en-US' : 'pt-BR', { maximumFractionDigits: 0 }).format(daily);
  }

  onSelectClick() {
    this.selectPlan.emit();
  }

  async confirmContactAction() {
    try {
      const modalRef = this.modalService.open(ConfirmActionModalComponent, { ariaLabelledBy: 'modal-confirm-deletion' });
      modalRef.componentInstance.content = {
        "en-us": "Do you want to request a custom plan for ReportsFeed from the Sales team?",
        "pt-br": "Você deseja receber um contato da equipe de vendas referente a um plano customizado?"
      };
      const result = await modalRef.result;
      return result === true;
    } catch(reason) {
      // Continue regardless (exceptions here are likely a modal close)
    }
    return false;
  }

  async onContactClick() {
    if (await this.confirmContactAction()) {
      try {
        const response = await this.paymentService.requestContact();
        console.log(response);
        if (!response) {
          throw new Error("Request for contact failed unexpectedly");
        }
        return await this.showModalSuccess(this.isEnglishLocale() ? "Our Sales team has been notified and will contact you shortly!" : "Nossa equipe de Vendas entrará em contato com você em breve!");
      } catch (err) {
        if (err.message === "Missing user data") {
          return await this.showModalError(this.isEnglishLocale() ? "Fill your account data in the account settings first!" : "Preencha os dados no seu cadastro primeiro!");
        } else {
          return await this.showModalError(err);
        }
      }
    }
  }

  async showModalError(err: any) {
    try {
      const modalRef = this.modalService.open(ConfirmActionModalComponent, { ariaLabelledBy: 'modal-confirm-deletion' });
      modalRef.componentInstance.content = err.toString();
      modalRef.componentInstance.title = {"en-us": "Could not send notification request", "pt-br": "Erro no envio da requisição de aviso"};
      modalRef.componentInstance.canCancel = false;
      const result = await modalRef.result;
      return result === true;
    } catch(reason) {
      // Continue regardless (exceptions here are likely a modal close)
    }
    return false;
  }

  async showModalSuccess(message: string) {
    try {
      const modalRef = this.modalService.open(ConfirmActionModalComponent, { ariaLabelledBy: 'modal-confirm-deletion' });
      modalRef.componentInstance.title = {"en-us": "Success", "pt-br": "Sucesso!"};
      modalRef.componentInstance.content = message;
      modalRef.componentInstance.canCancel = false;
      const result = await modalRef.result;
      return result === true;
    } catch(reason) {
      // Continue regardless (exceptions here are likely a modal close)
    }
    return false;
  }

}
